import {
  Component,
  ChangeDetectionStrategy,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuComponent } from '../components/menu/menu.component';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

interface Menu {
  index: number;
  name: string;
  title: string;
  url: string;
  parent: number | null; // null means no parent
  formId: number | null;
  new_tab: boolean | false;
  enable: boolean | true;
}

interface ReprtMenu {
  index: number;
  name: string;
  reporttitle: string;
  reportId: number | null;
  enable: boolean | true;
  formId: number | null;
  parent: number | null; // null means no parent
  new_tab: boolean | false;
}

@Component({
  selector: 'app-menu-editor',
  templateUrl: './menu-editor.component.html',
  styleUrls: ['./menu-editor.component.scss'],
})
export class MenuEditorComponent extends BaseListCtl {
  @Input() id: number = 0;
  @Input() usecaseId: number = 0;
  @ViewChild(MenuComponent) menuComponent!: MenuComponent;

  public curRoleId = 0;
  public curRole: any;
  public curMenus: any;
  public reportRoleId = 0;
  public reportRole: any;
  public reportMenus: any;
  private menusFetched = false; // A flag to prevent repeated calls
  private reportsFetched = false; // A flag to prevent repeated calls
  public nestedMenus: Menu[] = [];
  public reportlist: any = [];

  public menuform: any = {
    data: { index: 0 },
    inputerror: {}, // form input error messages
  };

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('endpoint.application', locator, route);

    let _self = this;
    if (route.snapshot.paramMap.get('appId'))
      _self.id = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));
  }

  override ngOnInit() {
    let _self = this;
    if (this.id) {
      _self.get(this.id, function () {
        console.log(_self.form.data);

        _self.getRolesList();
      });
      this.getApiList();
      this.getReports();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    let _self = this;
    if (changes['id']) {
      _self.get(this.id, function () {
        _self.getRolesList();
      });
      _self.getApiList();
    }
  }

  override save(): void {
    let _self = this;
    if (this.curRoleId == 0) {
      this.form.data.menus = this.curMenus;
      super.save();
    } else {
      if (_self.curRoleId > 0) {
        _self.curRole = _self.roles.find(
          (e: any) => e['id'] == _self.curRoleId
        );
        _self.curRole['menus'] = _self.curMenus;
        // save role in role end points
        _self.locator.config.get('endpoint.application.role');
        this.getData(
          'endpoint.application.role',
          '/save',
          _self.curRole,
          function (data: any, error: boolean, res: any) {
            if (error) {
              _self.form.error = true;
              _self.form.inputerror = res.result.inputerror;
              return;
            }
            _self.form.error = false;
            _self.form.message = 'Data is saved';
            _self.getRolesList();
          }
        );
      }
      if (_self.reportRoleId > 0) {
        _self.reportRole = _self.roles.find(
          (e: any) => e['id'] == _self.reportRoleId
        );
        _self.reportRole['reports'] = _self.reportMenus;
        // save role in role end points
        _self.locator.config.get('endpoint.application.role');
        this.getData(
          'endpoint.application.role',
          '/save',
          _self.reportRole,
          function (data: any, error: boolean, res: any) {
            if (error) {
              _self.form.error = true;
              _self.form.inputerror = res.result.inputerror;
              return;
            }
            _self.form.error = false;
            _self.form.message = 'Data is saved';
            _self.getRolesList();
          }
        );
      }
    }
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.code = data.code;
    form.appUrl = data.appUrl;
    form.userName = data.userName;
    form.userId = data.userId;
    form.orgName = data.orgName;
    form.status = data.status;
    if (data.reports) {
      form.reports = data.reports;
    }
    if (data.menus) {
      form.menus = data.menus;
    }
    form.logo = data.logo;
    form.enableUserSignup = data.enableUserSignup;
    form.roleId = data.roleId;
  }

  resetMenuForm() {
    this.menuform.data = { index: 0, role: 0 };
  }

  public usecases = [];

  async getApiList() {
    let _self = this;
    let searchParams = { appId: this.id };
    this.getData(
      'endpoint.usecase',
      '/search',
      searchParams,
      function (data: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.usecases = data;
      }
    );
  }

  public forms = [];

  async getFormList() {
    let _self = this;
    let searchParams = {
      userstoryId: Number(this.menuform.data['userstoryId']),
    };
    this.getData(
      'endpoint.ui.forms',
      '/search',
      searchParams,
      function (data: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.forms = data;
      }
    );
  }

  public roles = [];

  async getRolesList() {
    let _self = this;
    let searchParams = { applicationId: this.id };
    this.getData(
      'endpoint.application.role',
      '/search',
      searchParams,
      function (data: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.roles = data;
        _self.onRoleChange();
      }
    );
  }

  onRoleChange() {
    this.menusFetched = false; // Allow re-fetching menus for new role
    this.reportsFetched = false; // Allow re-fetching menus for new role
    this.getCurrentMenus(); // Fetch new menus based on the new role ID
    this.getCurrentReport(); // Fetch new menus based on the new role ID
    //this.getMenus();
  }

  async getMenus() {
    let _self = this;
    if (_self.curRoleId > 0) {
      let url =
        this.locator.config.get('endpoint.application.menus') +
        '/getMenus/' +
        _self.curRoleId;
      _self.locator.http.get(url, function (res: any, error: boolean) {
        console.log(res);
      });
    }
  }

  updateNestedMenus() {
    this.nestedMenus = this.getNestedMenus();
  }

  async getCurrentMenus() {
    let _self = this;
    // Fetch menus only if not fetched yet or if role has changed
    if (!_self.menusFetched) {
      _self.curMenus = [];
      if (_self.curRoleId > 0) {
        _self.curRole = _self.roles.find(
          (e: any) => e['id'] == _self.curRoleId
        );
        console.log('curRole ', _self.curRole);

        if (
          _self.curRole &&
          _self.curRole.menus &&
          _self.curRole.menus.length > 0
        ) {
          _self.curMenus = _self.mergeMenus(
            _self.curRole.menus,
            this.form.data.menus
          );
        } else {
          _self.curMenus = this.form.data.menus;
        }
      } else {
        // When no role is selected (global), use default application menus
        _self.curMenus = this.form.data.menus;
      }
      _self.menusFetched = true; // Mark as fetched to prevent redundant fetching
    }
  }

  async getCurrentReport() {
    let _self = this;
    // Fetch menus only if not fetched yet or if role has changed
    if (!_self.reportsFetched) {
      _self.reportMenus = [];
      if (_self.reportRoleId > 0) {
        _self.reportRole = _self.roles.find(
          (e: any) => e['id'] == _self.reportRoleId
        );

        if (
          _self.reportRole &&
          _self.reportRole.reports &&
          _self.reportRole.reports.length > 0
        ) {
          _self.reportMenus = _self.mergeMenus(
            _self.reportRole.reports,
            this.form.data.reports
          );
        } else {
          _self.reportMenus = this.form.data.reports;
        }
      } else {
        // When no role is selected (global), use default application menus
        _self.reportMenus = this.form.data.reports;
      }
      _self.reportsFetched = true; // Mark as fetched to prevent redundant fetching
    }
  }

  getData(endpoint: string, uri: string, searchParams: any, callback: any) {
    this.locator.config.getProperty(endpoint).then((property: string) => {
      let url = property + uri;
      this.locator.http.post(
        url,
        searchParams,
        function (res: any, error: boolean) {
          callback(res.result.data, error, res);
        }
      );
    });
  }

  getFormDetails() {
    let formId = Number(this.menuform.data['formId']);
    let form: any = this.forms.find((form: any) => form.id === formId);
    this.menuform.data['title'] = form['title'];
  }

  public selectedItemId: any;

  setSelectedItem(id: any) {
    this.selectedItemId = id;
  }

  confirmDelete() {
    this.delete(this.selectedItemId);
  }

  onFormChange(): void {
    let _self = this;
    let form: any = _self.forms.filter(
      (e: any) => e['id'] == _self.menuform.data['formId']
    );
    if (form && form[0] && form[0]['title']) {
      _self.menuform.data.title = form[0]['title'];
    }
  }

  mergeMenus(roleMenus: any[], appMenus: any[]): any[] {
    const mergedMenus = [...roleMenus];
    appMenus.forEach((appMenu) => {
      const matchingRoleMenu = mergedMenus.find(
        (menu) => menu.title === appMenu.title
      );
      if (matchingRoleMenu) {
        // Merge properties from appMenus with roleMenus, giving preference to roleMenus
        Object.assign(matchingRoleMenu, appMenu, {
          enable:
            matchingRoleMenu.enable !== undefined
              ? matchingRoleMenu.enable
              : appMenu.enable,
          new_tab:
            matchingRoleMenu.new_tab !== undefined
              ? matchingRoleMenu.new_tab
              : appMenu.new_tab,
        });
      } else {
        // If no matching index in roleMenus, add the appMenu as-is
        mergedMenus.push(appMenu);
      }
    });
    return mergedMenus;
  }

  // Add a new top-level menu item
  addMenu() {
    let _self = this;
    //_self.curMenus = [];
    if (!_self.menuform.data.title || _self.menuform.data.title == '') {
      alert(' title must required ');
      return;
    }
    // check empty menus have
    if (!_self.curMenus) {
      _self.curMenus = [];
    }

    if (_self.menuform.data.index > 0) {
      let menu_index = _self.menuform.data.index;
      _self.curMenus[menu_index - 1] = _self.menuform.data;
    } else {
      // check menu already exist
      if (_self.menuform.data['formId']) {
        let exist: any = _self.curMenus.filter(
          (e: any) => e['formId'] == _self.menuform.data['formId']
        );
        if (exist.length > 0) {
          _self.form['message'] = 'This menu has already been created';
          return;
        }
      }
      const index = _self.curMenus.length + 1;
      const menu: Menu = {
        index: index,
        name: _self.menuform.data.name || '',
        title: _self.menuform.data.title || '',
        formId: _self.menuform.data.formId || null,
        parent: null, // No parent means top-level menu
        url: _self.menuform.data.url || '',
        enable: true,
        new_tab: false,
      };
      _self.curMenus = [..._self.curMenus, menu];
      _self.menuform.data = {}; // Clear the form
    }
    _self.save();
  }

  getMenu(index: number) {
    this.menuform.data = this.curMenus[index];
  }

  getNestedMenus(): Menu[] {
    // Fetch menus only if not fetched yet
    if (!this.menusFetched) {
      this.getCurrentMenus();
    }
    // Now return the menus if available
    if (this.curMenus) {
      return this.curMenus.filter((menu: any) => menu.parent == null);
    }
    return [];
  }

  getNestedReports(): ReprtMenu[] {
    // Fetch menus only if not fetched yet
    if (!this.menusFetched) {
      this.getCurrentReport();
    }
    // Now return the menus if available
    if (this.reportMenus) {
      return this.reportMenus.filter((menu: any) => menu.parent == null);
    }
    return [];
  }

  expandAll(): void {
    if (this.menuComponent) {
      this.menuComponent.expandAll(); // Call expandAll on the MenuComponent instance
    }
  }

  moveNext(menu: any) {
    let index = menu.index;
    let _self = this;
    const currentIndex = index - 1;
    const previousMenuIndex = currentIndex;
    let current_menu = _self.curMenus[currentIndex];
    if (previousMenuIndex > 0) {
      _self.curMenus[currentIndex]['parent'] = previousMenuIndex;
      _self.save();
    } else {
      console.info('No previous menu exists to set as parent');
    }
  }

  moveBack(menu: any) {
    let index = menu.index;
    let _self = this;
    const currentIndex = index - 1;
    const previousMenuIndex = currentIndex - 1;
    let current_menu = _self.curMenus[currentIndex];
    if (current_menu['parent'] == null) {
      // top level menus
      return;
    }
    if (previousMenuIndex >= 0) {
      let previous_menu = _self.curMenus[previousMenuIndex];
      console.info('Current menu' + JSON.stringify(current_menu));
      console.info('Perent menu' + JSON.stringify(previous_menu));
      if (!previous_menu['parent']) {
        // Previous menu not have any perent
        // create Current menu is child of Previous menu
        console.info('No previous menu exists to set as parent');
        _self.curMenus[currentIndex]['parent'] = null;
      } else {
        // check have same parent
        if (current_menu['parent'] == previous_menu['parent']) {
          console.info('current menu parent equal to previous menu parent');
          const parent_index = _self.curMenus[currentIndex]['parent'] - 1;
          _self.curMenus[currentIndex]['parent'] =
            _self.curMenus[parent_index]['parent'];
        } else {
          console.info('No previous menu exists to set as parent');
          // previous menus parent-> perent compare  to current
          // get previous menu parent index
          const previous_menu_parent_index =
            _self.curMenus[previousMenuIndex]['parent'] - 1;
          console.info(_self.curMenus[previous_menu_parent_index]);
          let previous_menu_parent_menu =
            _self.curMenus[previous_menu_parent_index];
          if (
            _self.curMenus[currentIndex]['parent'] ==
            previous_menu_parent_menu['parent']
          ) {
            console.info('Current ->parent and previous-> parent are equal');
            _self.curMenus[currentIndex]['parent'] =
              _self.curMenus[previous_menu_parent_menu['parent'] - 1]['parent'];
          } else {
            _self.curMenus[currentIndex]['parent'] =
              _self.curMenus[previousMenuIndex]['parent'];
          }
        }
      }
    } else {
      console.info('No previous menu exists to set as parent');
    }
    _self.save();
  }

  onChangeEnable(menu: any) {
    this.curMenus[menu.index - 1]['enable'] = menu.enable;
    this.save();
  }

  onChangeNewTab(menu: any) {
    this.curMenus[menu.index - 1]['new_tab'] = menu.new_tab;
    this.save();
  }

  move(menu: any, move: string) {
    let ind = menu.index + 1;
    if ('up' == move) {
      ind = menu.index - 1;
    }

    let _self = this;

    if ('up' == move && ind > 0) {
      let moveIndex = ind - 1;
      // Swap elements
      let temp = _self.curMenus[ind];
      temp.index = ind;
      _self.curMenus[ind] = _self.curMenus[moveIndex];
      _self.curMenus[moveIndex] = temp;
      _self.curMenus[ind].index = ind + 1;

      // check element not have self perent
      if (_self.curMenus[ind].index === _self.curMenus[ind].parent)
        _self.curMenus[ind].parent = null;

      if (_self.curMenus[moveIndex].index === _self.curMenus[moveIndex].parent)
        _self.curMenus[moveIndex].parent = null;

      // fixed have incorrect parent
      if (_self.curMenus[ind].parent !== _self.curMenus[moveIndex].parent)
        _self.curMenus[ind].parent = _self.curMenus[moveIndex].index;

      _self.save();
    }

    if ('down' == move && ind + 1 < _self.curMenus.length) {
      let moveIndex = ind + 1;
      let temp = _self.curMenus[ind];
      temp.index = moveIndex + 1;
      _self.curMenus[ind] = _self.curMenus[moveIndex];
      _self.curMenus[moveIndex] = temp;
      _self.curMenus[ind].index = ind + 1;

      if (_self.curMenus[ind].index === _self.curMenus[ind].parent)
        _self.curMenus[ind].parent = null;

      if (_self.curMenus[moveIndex].index === _self.curMenus[moveIndex].parent)
        _self.curMenus[moveIndex].parent = null;

      _self.save();
    }
  }

  remove(menu: any) {
    let index = menu.index;

    this.curMenus = this.curMenus.filter(
      (menu: Menu) => menu.index !== index && menu.parent !== index
    );
    // Re-index the menus
    this.curMenus.forEach((menu: Menu, i: number) => {
      menu.index = i + 1;
    });

    this.save();
  }

  public callParentMethod(menu: any, type: string) {
    let _self = this;
    switch (type) {
      case 'enable':
        console.info(`Enable changed for menu ${menu.index}: ${menu.enable}`);
        // Add your enable-specific logic here
        _self.onChangeEnable(menu);
        break;
      case 'newTab':
        console.info(`New Tab changed for menu ${menu.index}: ${menu.new_tab}`);
        // Add your newTab-specific logic here
        _self.onChangeNewTab(menu);
        break;
      case 'moveUp':
        console.info(`Move Up for menu ${menu.index}`);
        // Add logic to move the menu up
        _self.move(menu, 'up');
        break;
      case 'moveDown':
        console.info(`Move Down for menu ${menu.index}`);
        // Add logic to move the menu down
        _self.move(menu, 'down');
        break;
      case 'moveNext':
        console.info(`Add Child to menu ${menu.index}`);
        // Add logic to add a child menu
        _self.moveNext(menu);
        break;
      case 'moveBack':
        console.info(`Back Child for menu ${menu.index}`);
        // Add logic to move the menu back to a parent
        _self.moveBack(menu);
        break;
      case 'remove':
        console.info(`Remove menu ${menu.index}`);
        // Add logic to remove the menu
        _self.remove(menu);
        break;
      default:
        console.error('Unknown event type');
        break;
    }
  }

  getReports(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';
    let searchParams = { applicationId: this.id };
    _self.locator.config
      .getProperty('endpoint.reports')
      .then((property: string) => {
        let url = property + '/search';

        _self.locator.http.post(
          url,
          searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }
              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.reportlist = res.result.data;

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          }
        );
      });
  }

  addReport() {
    let _self = this;
    //_self.curMenus = [];
    console.log('tets');

    if (
      !_self.menuform.data.reporttitle ||
      _self.menuform.data.reporttitle == ''
    ) {
      alert(' Report title must required ');
      return;
    }
    // check empty menus have
    if (!_self.reportMenus) {
      _self.reportMenus = [];
    }

    if (_self.menuform.data.index > 0) {
      let menu_index = _self.menuform.data.index;
      _self.reportMenus[menu_index - 1] = _self.menuform.data;
    } else {
      // check menu already exist
      if (_self.menuform.data['reportId']) {
        let exist: any = _self.reportMenus.filter(
          (e: any) => e['reportId'] == _self.menuform.data['reportId']
        );
        if (exist.length > 0) {
          alert('return');
          _self.form['message'] = 'This menu has already been created';
          return;
        }
      }
      const index = _self.reportMenus.length + 1;
      const reprtMenu: ReprtMenu = {
        index: index,
        name: _self.menuform.data.name || '',
        reporttitle: _self.menuform.data.reporttitle || '',
        reportId: _self.menuform.data.reportId || null,
        formId: _self.menuform.data.formId || null,
        parent: null, // No parent means top-level menu
        enable: true,
        new_tab: false,
      };
      _self.reportMenus = [..._self.reportMenus, reprtMenu];
      _self.menuform.data = {}; // Clear the form
    }
    _self.saveReport();
  }

  saveReport(): void {
    let _self = this;
    if (this.reportRoleId == 0) {
      this.form.data.reports = this.reportMenus;
      super.save();
    } else {
      if (_self.reportRoleId > 0) {
        _self.reportRole = _self.roles.find(
          (e: any) => e['id'] == _self.reportRoleId
        );
        _self.reportRole['reports'] = _self.reportMenus;
        // save role in role end points
        _self.locator.config.get('endpoint.application.role');
        this.getData(
          'endpoint.application.role',
          '/save',
          _self.reportRole,
          function (data: any, error: boolean, res: any) {
            if (error) {
              _self.form.error = true;
              _self.form.inputerror = res.result.inputerror;
              return;
            }
            _self.form.error = false;
            _self.form.message = 'Data is saved';
            _self.getRolesList();
          }
        );
      }
    }
  }

  async getReport(id: any, callback?: any) {
    let _self = this;
    if (!id || id == 0) {
      if (callback) {
        callback();
      }
      return;
    }
    try {
      const property = await _self.locator.config.getProperty(
        'endpoint.reports'
      );
      const url = `${property}/get/${id}`;
      this.locator.http.get(url, function (res: any, error: any) {
        if (error) {
          return;
        }
        _self.form.error = !res.success;
        _self.form.message = res.result.message;
        // Handle the response
        if (res.success) {
          _self.menuform.data['formId'] = res.result.data['uiFormId'];
        } else {
          _self.form.error = true;
          _self.form.message = res.result.message;
        }
        // Invoke the callback if provided
        if (callback) {
          callback();
        }
      });
    } catch (error) {
      console.error('Error fetching report:', error);
    }
  }

  public callReportParentMethod(menu: any, type: string) {
    let _self = this;
    switch (type) {
      case 'enable':
        console.info(`Enable changed for menu ${menu.index}: ${menu.enable}`);
        // Add your enable-specific logic here
        _self.onRepChangeEnable(menu);
        break;
      case 'newTab':
        console.info(`New Tab changed for menu ${menu.index}: ${menu.new_tab}`);
        // Add your newTab-specific logic here
        _self.onRepChangeNewTab(menu);
        break;
      case 'moveUp':
        console.info(`Move Up for menu ${menu.index}`);
        // Add logic to move the menu up
        _self.moveRep(menu, 'up');
        break;
      case 'moveDown':
        console.info(`Move Down for menu ${menu.index}`);
        // Add logic to move the menu down
        _self.moveRep(menu, 'down');
        break;
      case 'moveNext':
        console.info(`Add Child to menu ${menu.index}`);
        // Add logic to add a child menu
        _self.moveRepNext(menu);
        break;
      case 'moveBack':
        console.info(`Back Child for menu ${menu.index}`);
        // Add logic to move the menu back to a parent
        _self.moveRepBack(menu);
        break;
      case 'remove':
        console.info(`Remove menu ${menu.index}`);
        // Add logic to remove the menu
        _self.removeRep(menu);
        break;
      default:
        console.error('Unknown event type');
        break;
    }
  }

  onRepChangeEnable(menu: any) {
    this.reportMenus[menu.index - 1]['enable'] = menu.enable;
    this.saveReport();
  }
  onRepChangeNewTab(menu: any) {
    this.reportMenus[menu.index - 1]['new_tab'] = menu.new_tab;
    this.saveReport();
  }

  moveRep(menu: any, move: string) {
    let ind = menu.index + 1;
    if ('up' == move) {
      ind = menu.index - 1;
    }

    let _self = this;

    if ('up' == move && ind > 0) {
      let moveIndex = ind - 1;
      // Swap elements
      let temp = _self.reportMenus[ind];
      temp.index = ind;
      _self.reportMenus[ind] = _self.reportMenus[moveIndex];
      _self.reportMenus[moveIndex] = temp;
      _self.reportMenus[ind].index = ind + 1;

      // check element not have self perent
      if (_self.reportMenus[ind].index === _self.reportMenus[ind].parent)
        _self.reportMenus[ind].parent = null;

      if (
        _self.reportMenus[moveIndex].index ===
        _self.reportMenus[moveIndex].parent
      )
        _self.reportMenus[moveIndex].parent = null;

      // fixed have incorrect parent
      if (_self.reportMenus[ind].parent !== _self.reportMenus[moveIndex].parent)
        _self.reportMenus[ind].parent = _self.reportMenus[moveIndex].index;

      _self.saveReport();
    }

    if ('down' == move && ind + 1 < _self.reportMenus.length) {
      let moveIndex = ind + 1;
      let temp = _self.reportMenus[ind];
      temp.index = moveIndex + 1;
      _self.reportMenus[ind] = _self.reportMenus[moveIndex];
      _self.reportMenus[moveIndex] = temp;
      _self.reportMenus[ind].index = ind + 1;

      if (_self.reportMenus[ind].index === _self.reportMenus[ind].parent)
        _self.reportMenus[ind].parent = null;

      if (
        _self.reportMenus[moveIndex].index ===
        _self.reportMenus[moveIndex].parent
      )
        _self.reportMenus[moveIndex].parent = null;

      _self.saveReport();
    }
  }

  moveRepNext(menu: any) {
    let index = menu.index;
    let _self = this;
    const currentIndex = index - 1;
    const previousMenuIndex = currentIndex;
    let current_menu = _self.reportMenus[currentIndex];
    if (previousMenuIndex > 0) {
      _self.reportMenus[currentIndex]['parent'] = previousMenuIndex;
      _self.saveReport();
    } else {
      console.info('No previous menu exists to set as parent');
    }
  }

  moveRepBack(menu: any) {
    let index = menu.index;
    let _self = this;
    const currentIndex = index - 1;
    const previousMenuIndex = currentIndex - 1;
    let current_menu = _self.reportMenus[currentIndex];
    if (current_menu['parent'] == null) {
      // top level menus
      return;
    }
    if (previousMenuIndex >= 0) {
      let previous_menu = _self.reportMenus[previousMenuIndex];
      console.info('Current menu' + JSON.stringify(current_menu));
      console.info('Perent menu' + JSON.stringify(previous_menu));
      if (!previous_menu['parent']) {
        // Previous menu not have any perent
        // create Current menu is child of Previous menu
        console.info('No previous menu exists to set as parent');
        _self.reportMenus[currentIndex]['parent'] = null;
      } else {
        // check have same parent
        if (current_menu['parent'] == previous_menu['parent']) {
          console.info('current menu parent equal to previous menu parent');
          const parent_index = _self.reportMenus[currentIndex]['parent'] - 1;
          _self.reportMenus[currentIndex]['parent'] =
            _self.reportMenus[parent_index]['parent'];
        } else {
          console.info('No previous menu exists to set as parent');
          // previous menus parent-> perent compare  to current
          // get previous menu parent index
          const previous_menu_parent_index =
            _self.reportMenus[previousMenuIndex]['parent'] - 1;
          console.info(_self.reportMenus[previous_menu_parent_index]);
          let previous_menu_parent_menu =
            _self.reportMenus[previous_menu_parent_index];
          if (
            _self.reportMenus[currentIndex]['parent'] ==
            previous_menu_parent_menu['parent']
          ) {
            console.info('Current ->parent and previous-> parent are equal');
            _self.reportMenus[currentIndex]['parent'] =
              _self.reportMenus[previous_menu_parent_menu['parent'] - 1][
                'parent'
              ];
          } else {
            _self.reportMenus[currentIndex]['parent'] =
              _self.reportMenus[previousMenuIndex]['parent'];
          }
        }
      }
    } else {
      console.info('No previous menu exists to set as parent');
    }
    _self.saveReport();
  }

  removeRep(menu: any) {
    let index = menu.index;

    this.reportMenus = this.reportMenus.filter(
      (menu: Menu) => menu.index !== index && menu.parent !== index
    );
    // Re-index the menus
    this.reportMenus.forEach((menu: Menu, i: number) => {
      menu.index = i + 1;
    });

    this.saveReport();
  }

  //--------------------------------------------------------------------------------------------------------------------------------------------

  /**
   * save menu
   */
  saveMenu(callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.inputerror = {};
    _self.locator.config
      .getProperty('endpoint.api.v1')
      .then((property: any) => {
        let url = property + '/menus/save';
        this.locator.http.post(
          url,
          this.form.data,
          function (res: any, error: any) {
            if (error) {
              return;
            }
            _self.form.error = !res.success;
            _self.form.message = res.result.message;
            if (res.success) {
              _self.form.message = 'Data is saved';
              // Set a 2-second delay to call clearMessage
              setTimeout(() => {
                _self.clearMessage(_self.form);
              }, 5000);
              if (callback) {
                callback();
              }
            } else {
              _self.form.inputerror = res.result.inputerror;
            }
          }
        );
      });
  }

  /**
   * Search menu
   * @param callback
   */
  searchMenu(callback?: any) {
    var _self = this;
    _self.form.searchError = false;
    _self.form.searchMessage = '';
    this.locator.config
      .getProperty(_self.api.endpoint)
      .then((property: any) => {
        let url = _self.api.search + '/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;
        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }
              return;
            }
            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];
            if (res.success) {
              _self.form.list = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }
              //Check empty list
              if (_self.form.list.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }
              // Add data in Datatable
              //_self.initializeDataTable();
              if (callback) {
                callback();
              }
            }
            if (callback) {
              callback();
            }
          }
        );
      });
  }
}
